module.exports = __webpack_public_path__ + "img/hu.506909b2.svg";